export default "__VITE_ASSET__CamjjgbA__"